export const contractStatuses = [
  { value: 'active', label: 'ساري' },
  { value: 'expiring_soon', label: 'قارب على الانتهاء' },
  { value: 'expired', label: 'منتهي' },
  { value: 'suspended', label: 'معلق' },
];

export const statusLabel = (status) => contractStatuses.find((item) => item.value === status)?.label || status || '—';
export const number = (value) =>
  new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(Number(value) || 0);
export const percentage = (value) =>
  new Intl.NumberFormat('en-US', { maximumFractionDigits: 4 }).format(Number(value) || 0);
export const dateOnly = (value) => (value ? String(value).slice(0, 10) : '—');
export const fileSize = (value) =>
  Number(value) >= 1024 * 1024 ? `${number(Number(value) / 1024 / 1024)} MB` : `${number(Number(value) / 1024)} KB`;
export const today = () => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Riyadh',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const value = (key) => parts.find((part) => part.type === key)?.value;
  return `${value('year')}-${value('month')}-${value('day')}`;
};
export const normalizePhone = (value) =>
  String(value || '')
    .replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)))
    .replace(/[۰-۹]/g, (digit) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
    .replace(/[\s()-]/g, '')
    .replace(/^\+/, '')
    .replace(/^00966/, '966')
    .replace(/^966/, '0');

export function attachmentKind(attachment) {
  if (!attachment) return '';
  if (attachment.mimeType === 'application/pdf' || /\.pdf$/i.test(attachment.name)) return 'pdf';
  if (/^image\//i.test(attachment.mimeType || '') || /\.(png|jpe?g|webp)$/i.test(attachment.name)) return 'image';
  return 'document';
}

export function validateFile(file, templates = false) {
  if (!file) return '';
  if (file.size > 15 * 1024 * 1024) return 'الحد الأقصى لحجم الملف 15 MB';
  if (!(templates ? /\.(pdf|docx?)$/i : /\.(pdf|docx?|png|jpe?g|webp)$/i).test(file.name))
    return templates ? 'اختر ملف PDF أو Word' : 'اختر ملف PDF أو Word أو صورة PNG أو JPG أو WebP';
  return '';
}

export async function authenticatedDownload(http, url, name) {
  const { data } = await http.get(url, { responseType: 'blob' });
  const objectUrl = URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}

export async function errorMessage(context, error) {
  if (typeof Blob !== 'undefined' && error?.response?.data instanceof Blob) {
    try {
      const body = JSON.parse(await error.response.data.text());
      if (body.msg) return body.msg;
    } catch (_) {
    }
  }
  return context.$globalError(error);
}
